import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 7,
	height: 11,
	viewBox: "0 0 7 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.74238 0C1.64477 0 1.55116 0.0405624 1.48214 0.112764C1.41312 0.184965 1.37434 0.282892 1.37434 0.385V10.23H0.368034C0.270425 10.23 0.176814 10.2706 0.107795 10.3428C0.038775 10.415 0 10.5129 0 10.615C0 10.7171 0.038775 10.815 0.107795 10.8872C0.176814 10.9594 0.270425 11 0.368034 11H2.99685C3.09445 11 3.18807 10.9594 3.25708 10.8872C3.3261 10.815 3.36488 10.7171 3.36488 10.615C3.36488 10.5129 3.3261 10.415 3.25708 10.3428C3.18807 10.2706 3.09445 10.23 2.99685 10.23H2.11041V5.17H6.63197C6.72958 5.17 6.82319 5.12944 6.89221 5.05724C6.96123 4.98503 7 4.88711 7 4.785V0.385C7 0.282892 6.96123 0.184965 6.89221 0.112764C6.82319 0.0405624 6.72958 0 6.63197 0H1.79495C1.78604 7.05719e-05 1.77713 0.000437424 1.76824 0.0011C1.75963 0.00045576 1.75101 8.892e-05 1.74238 0Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgFlag);
export { ForwardRef as ReactComponent };
